import { __awaiter, __decorate, __extends, __generator, __metadata } from "tslib";
import { Utils } from '../Utils';
import { Observable } from '../Model/Decorators';
import NeoModel from "../Model/NeoModel";
var AsyncDataSource = /** @class */ (function () {
    function AsyncDataSource(defaultData) {
        this.isLoading = false;
        this.fetchError = null;
        this.promise = null;
        this.hasFetched = false;
        this.data = defaultData;
    }
    Object.defineProperty(AsyncDataSource.prototype, "willLoad", {
        get: function () {
            return this.isLoading || !this.hasFetched;
        },
        enumerable: false,
        configurable: true
    });
    AsyncDataSource.prototype.executeFetchAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data_1, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.isLoading && !this.fetchError)) return [3 /*break*/, 4];
                        this.isLoading = true;
                        this.promise = this.getDataAsync();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.promise];
                    case 2:
                        data_1 = _a.sent();
                        Utils.batchUpdate(function () {
                            _this.data = data_1;
                            _this.isLoading = false;
                        });
                        return [2 /*return*/, data_1];
                    case 3:
                        e_1 = _a.sent();
                        this.isLoading = false;
                        this.fetchError = e_1;
                        console.log(e_1);
                        throw e_1;
                    case 4: return [2 /*return*/, this.promise];
                }
            });
        });
    };
    AsyncDataSource.prototype.fetchDataAsync = function (clearPreviousError) {
        if (clearPreviousError === void 0) { clearPreviousError = false; }
        this.hasFetched = true;
        if (clearPreviousError) {
            this.fetchError = null;
        }
        this.executeFetchAsync();
        return this.promise;
    };
    AsyncDataSource.prototype.fetchInitial = function () {
        if (!this.hasFetched) {
            this.fetchDataAsync();
        }
        return this.promise;
    };
    __decorate([
        Observable(),
        __metadata("design:type", Boolean)
    ], AsyncDataSource.prototype, "isLoading", void 0);
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], AsyncDataSource.prototype, "data", void 0);
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], AsyncDataSource.prototype, "fetchError", void 0);
    return AsyncDataSource;
}());
export { AsyncDataSource };
var CallbackDataSource = /** @class */ (function (_super) {
    __extends(CallbackDataSource, _super);
    function CallbackDataSource(callBack, defaultData) {
        var _this = _super.call(this, defaultData) || this;
        _this.callBack = callBack;
        _this.defaultData = defaultData;
        return _this;
    }
    CallbackDataSource.prototype.getDataAsync = function () {
        return this.callBack();
    };
    CallbackDataSource = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [Function, Object])
    ], CallbackDataSource);
    return CallbackDataSource;
}(AsyncDataSource));
export { CallbackDataSource };
